import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header class=\"max-w-screen-2xl mx-auto px-8 py-6\"><div class=\"max-w-md\"><h1 class=\"text-4xl font-bold\">CSS Animatable</h1><h4 class=\"text-lg font-semibold mb-4\"> A place to get quick inspiration for css animations. </h4><p> Data pulled from <a href=\"https://github.com/mdn/data/blob/master/css/properties.json\" target=\"_blank\" rel=\"noopener noreferrer\">mdn-data</a>. <br> *List of <a href=\"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_animated_properties\" target=\"_blank\" rel=\"noopener noreferrer\">animatable css properties</a>. </p></div></header>", 1)
const _hoisted_2 = { class: "max-w-screen-2xl mx-auto px-8" }
const _hoisted_3 = { class: "flex flex-wrap -mx-8" }
const _hoisted_4 = { class: "bg-gray-100" }
const _hoisted_5 = { class: "max-w-screen-2xl mx-auto px-8 py-6 text-sm text-gray-500 mt-8 lg:mt-0" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("i", null, [
    /*#__PURE__*/_createTextVNode("Code @ "),
    /*#__PURE__*/_createVNode("a", {
      href: "https://github.com/simboonlong/css-animatable",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Github"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("i", null, [
    /*#__PURE__*/_createTextVNode(" Author © "),
    /*#__PURE__*/_createVNode("a", {
      href: "http://simboonlong.com",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Sim Boon Long"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Demo = _resolveComponent("Demo")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _createVNode("ul", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cssPropertiesFiltered, (value, key, index) => {
          return (_openBlock(), _createBlock("li", {
            class: "w-full lg:w-1/2 px-8",
            key: index
          }, [
            _createVNode(_component_Demo, {
              name: key,
              data: value,
              demoIndex: index
            }, null, 8, ["name", "data", "demoIndex"])
          ]))
        }), 128))
      ])
    ]),
    _createVNode("footer", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("p", null, " Total css properties from mdn-data: " + _toDisplayString(Object.keys(_ctx.properties).length), 1),
        _createVNode("p", _hoisted_6, " *Filtered to animatable css properties + standard + non vendor prefixes: " + _toDisplayString(Object.keys(_ctx.cssPropertiesFiltered).length), 1),
        _hoisted_7,
        _hoisted_8
      ])
    ])
  ], 64))
}